'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = require('react-redux');

var _elementActions = require('../../element/elementActions');

var _selectionActions = require('../../element/selection/selectionActions');

var _draftJs = require('draft-js');

var _cardConstants = require('../../../common/cards/cardConstants');

var _linkConstants = require('../../../common/links/linkConstants');

var _imageConstants = require('../../../common/images/imageConstants');

// TODO Expose this in an "editor" function


// Action creators
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    var deselectAll = function deselectAll() {
        return dispatch((0, _selectionActions.deselectAllElements)());
    };

    var createShortcutElement = function createShortcutElement(_ref) {
        var elementType = _ref.elementType,
            location = _ref.location,
            content = _ref.content,
            attachment = _ref.attachment,
            currentBoardId = _ref.currentBoardId;

        // Default the current board ID to the drop location if not provided, to simplify the API
        var _currentBoardId = currentBoardId || location.parentId;

        return dispatch((0, _elementActions.createAndSelectElement)({
            elementType: elementType,
            location: location,
            attachment: attachment,
            content: content,
            currentBoardId: _currentBoardId
        }));
    };

    var createShortcutCard = function createShortcutCard(_ref2) {
        var location = _ref2.location,
            currentBoardId = _ref2.currentBoardId,
            textContent = _ref2.textContent,
            text = _ref2.text,
            html = _ref2.html;

        var elementConfig = {
            elementType: _cardConstants.CARD_TYPE,
            location: location,
            currentBoardId: currentBoardId
        };

        var _textContent = void 0;
        if (textContent) {
            _textContent = textContent;
        } else if (html) {
            var blocksFromHtml = (0, _draftJs.convertFromHTML)(html);
            var contentState = _draftJs.ContentState.createFromBlockArray(blocksFromHtml);
            _textContent = (0, _draftJs.convertToRaw)(contentState);
        } else if (text) {
            // TODO Figure out how to keep styles with the editor
            // TODO Expose this in an "editor" function
            var _contentState = _draftJs.ContentState.createFromText(text);
            _textContent = (0, _draftJs.convertToRaw)(_contentState);
        }

        if (_textContent) {
            elementConfig.content = { textContent: _textContent };
        }

        return createShortcutElement(elementConfig);
    };

    var createShortcutImage = function createShortcutImage(_ref3) {
        var location = _ref3.location,
            currentBoardId = _ref3.currentBoardId,
            file = _ref3.file,
            caption = _ref3.caption,
            _ref3$showCaption = _ref3.showCaption,
            showCaption = _ref3$showCaption === undefined ? true : _ref3$showCaption;

        var elementConfig = {
            elementType: _imageConstants.IMAGE_TYPE,
            location: location,
            attachment: file,
            currentBoardId: currentBoardId
        };

        if (caption) {
            elementConfig.content = {
                showCaption: showCaption,
                caption: caption
            };
        }

        return createShortcutElement(elementConfig);
    };

    var createShortcutLink = function createShortcutLink(_ref4) {
        var location = _ref4.location,
            currentBoardId = _ref4.currentBoardId,
            url = _ref4.url;
        return createShortcutElement({
            elementType: _linkConstants.LINK_TYPE,
            location: location,
            content: { temp: { url: url, error: null } },
            currentBoardId: currentBoardId
        });
    };

    return {
        deselectAll: deselectAll,
        createShortcutElement: createShortcutElement,
        createShortcutCard: createShortcutCard,
        createShortcutImage: createShortcutImage,
        createShortcutLink: createShortcutLink
    };
};

// Constants
exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/shortcuts/elementShortcutsDecorator.js
// module id = 2216
// module chunks = 0